import { ShieldAlert, TrendingUp, User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const ITEMS = [
  {
    icon: User,
    title: "Personlig Information",
    bullets: [
      "Hemmadress",
      "Personnummer / födelsedata",
      "Familj och släktingar",
    ],
  },
  {
    icon: TrendingUp,
    title: "Offentlig & Ekonomisk Data",
    bullets: [
      "Inkomstintervall",
      "Fastighets- och adresshistorik",
      "Platser kopplade till ditt namn",
    ],
  },
  {
    icon: ShieldAlert,
    title: "Säkerhetsrisker",
    bullets: [
      "Bilder kopplade till namn och profiler",
      "Potentiellt läckta konton och inloggningsuppgifter",
    ],
  },
];

export function PublicKnowledge() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <p className="font-bold text-3xl text-center tracking-tight">
          Detta är redan offentligt om dig.
        </p>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto">
          Information som kan användas av bedragare, marknadsförare eller vem
          som helst som söker på ditt namn. Det ökar risken för ID-kapning,
          bedrägerier och oönskad kontakt.
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map(({ icon: Icon, title, bullets }) => (
          <Card
            key={title}
            className="border-red-300 dark:border-red-900 transition-all duration-200 hover:border-red-500 hover:shadow-lg"
          >
            <CardHeader>
              <div className="size-10 bg-red-100 dark:bg-red-900/30 rounded-xl flex justify-center items-center">
                <Icon className="text-red-500 dark:text-red-400" />
              </div>
              <CardTitle className="text-sm">{title}</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="list-disc pl-5 space-y-1 text-red-500 dark:text-red-400">
                {bullets.map((b) => (
                  <li key={b}>
                    <span className="text-muted-foreground text-sm">{b}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>

      <p className="text-center text-muted-foreground">
        Echorai hjälper dig att identifiera och minska denna exponering.
      </p>
    </div>
  );
}
